import { ActionTypes } from 'constants/index';

export function startup() {
  return {
    type: ActionTypes.STARTUP,
  };
}
